import { type ReactNode, useState } from 'react';
import { Trophy } from 'lucide-react';

const POP =
  'pointer-events-none absolute bottom-full left-1/2 z-50 mb-1 -translate-x-1/2 whitespace-nowrap rounded-md bg-surface-elevated px-sm py-1 text-[10px] text-text-secondary shadow-lg transition-all duration-150';

export function GoalMarker({ goal }: { goal: number }): ReactNode {
  const [show, setShow] = useState(false);
  const vis = show ? 'translate-y-0 opacity-100' : 'translate-y-1 opacity-0';
  return (
    <div
      className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/2"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <div className="flex h-4 w-4 items-center justify-center rounded-full bg-surface-elevated ring-1 ring-brand-red">
        <Trophy size={8} className="text-text-primary" />
      </div>
      <div className={`${POP} ${vis}`}>
        Meta{' '}
        <span className="font-mono tabular-nums text-text-primary">{goal}</span>
      </div>
    </div>
  );
}
